import React from 'react';

function StepPrivacy({ consents, onConsentChange }) {
  return (
    <div data-testid="cauzioni-step-privacy">
      <div className="cauzioni-info-card">
        <div className="cauzioni-card-body">
          <h2 className="cauzioni-card-title mb-3">Privacy e Consensi</h2>

          <div className="cauzioni-privacy-text">
            <p>
              Registrandomi dichiaro di aver preso visione dell&apos;informativa privacy resa ai
              sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679 (GDPR) da Greenia S.r.l.,
              titolare del trattamento dei dati personali per il sito Greenia.it. Il trattamento
              dei dati per finalità di marketing avviene solo previo consenso espresso
              dell&apos;interessato.
            </p>
          </div>

          <div className="cauzioni-consent-block">
            <h3 className="cauzioni-consent-title">Marketing diretto di Greenia</h3>
            <p className="cauzioni-consent-description">
              Acconsento al trattamento dei miei dati personali per attività di marketing: invio
              di newsletter e materiale promozionale, comunicazioni commerciali, ricerche di
              mercato e rilevazioni di qualità. Queste attività possono avvenire con strumenti
              automatizzati (email, SMS, messaggistica istantanea) e tradizionali (chiamate
              tramite operatore).
            </p>
            <div className="cauzioni-consent-radios">
              <label className="cauzioni-consent-option">
                <input
                  type="radio"
                  name="consent_marketing"
                  checked={consents.marketing === true}
                  onChange={() => onConsentChange('marketing', true)}
                />
                <span>Presto il consenso</span>
              </label>
              <label className="cauzioni-consent-option">
                <input
                  type="radio"
                  name="consent_marketing"
                  checked={consents.marketing === false}
                  onChange={() => onConsentChange('marketing', false)}
                />
                <span>Nego il consenso</span>
              </label>
            </div>
            {consents.marketing !== true && consents.attempted && (
              <p className="cauzioni-consent-error">È necessario prestare il consenso per proseguire.</p>
            )}
          </div>

          <div className="cauzioni-consent-block">
            <h3 className="cauzioni-consent-title">Comunicazione a terzi</h3>
            <p className="cauzioni-consent-description">
              Acconsento alla comunicazione dei miei dati personali a società partner di Greenia
              per finalità di informazione commerciale, indagini statistiche, ricerche di mercato
              e offerte dirette dei loro prodotti e servizi. Queste attività possono avvenire con
              modalità di contatto tradizionali e automatizzate.
            </p>
            <div className="cauzioni-consent-radios">
              <label className="cauzioni-consent-option">
                <input
                  type="radio"
                  name="consent_third_party"
                  checked={consents.thirdParty === true}
                  onChange={() => onConsentChange('thirdParty', true)}
                />
                <span>Presto il consenso</span>
              </label>
              <label className="cauzioni-consent-option">
                <input
                  type="radio"
                  name="consent_third_party"
                  checked={consents.thirdParty === false}
                  onChange={() => onConsentChange('thirdParty', false)}
                />
                <span>Nego il consenso</span>
              </label>
            </div>
            {consents.thirdParty !== true && consents.attempted && (
              <p className="cauzioni-consent-error">È necessario prestare il consenso per proseguire.</p>
            )}
          </div>

          <p className="cauzioni-consent-footer">
            Il consenso può essere revocato in qualsiasi momento scrivendo a
            {' '}
            <a href="mailto:privacy@greenia.it">privacy@greenia.it</a>
            {' '}
            oppure tramite il link di disiscrizione presente in ogni comunicazione.
          </p>
        </div>
      </div>
    </div>
  );
}

export default StepPrivacy;
